import { useAuth } from '@/hooks/use-auth';
import type { ViewerContext } from '@/utils/member-display';

/**
 * Produces a `ViewerContext` for callers that need to invoke
 * `memberDisplay()` (the plain function) inside a loop or data-building
 * step where React hooks cannot be called per-item.
 *
 * Prefer `useMemberDisplay(member)` when resolving a single member in JSX.
 */
export function useViewerContext(): ViewerContext {
  const { user } = useAuth();
  return {
    viewerId: user?.id ?? '',
    viewerRole: user?.role ?? 'collector',
  };
}
